export default __webpack_public_path__ + "static/media/tirana_ime.8e88621e.png";